import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'BuckeyeCableTheme',
  code: 'buckeyecable',
  colors: {
    headerBackground: '#fff',
    headerText: '#212529',
    headerBorder: '#e0e7e9',
    background: '#FFFFFF',
    footerBackground: '#f2f2f2',
    footerText: '#8c8c8c',
    footerBorder: '#e0e7e9',
    progressBar: '#d52222',
  },
  logoSize: {
    width: '195px',
    height: '48px',
  },
  baseColors: {
    link: '#d52222',
    cta: '#d52222',
    hover: '#05a2f6',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const BuckeyeCableTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
